import React from 'react';
import { useParams, useHistory, useLocation } from 'react-router-dom';
import Container from 'components/Container';
import ContainerHeader from 'components/ContainerHeader';
import { H3 } from 'components/Heading';
import PitPayTermsContent from './PitPayTermsContent';
import { PageContainer, BackLink, TermsContent } from './style';
import TicketHossTermsContent from './TicketHossTermsContent';

const TermsOfService = () => {
  const { type } = useParams();
  const history = useHistory();
  const location = useLocation();
  const { pathname } = location;

  const isTrackAdmin = pathname?.includes('admin-track');
  const isEmployeeAdmin = pathname?.includes('admin-employee');
  const routePrefix = isTrackAdmin
    ? '/admin-track'
    : isEmployeeAdmin
    ? '/admin-employee'
    : '/admin';

  const isPitPay = type === 'pitpay';
  const title = isPitPay
    ? 'Pit Pay Terms of Service'
    : 'Ticket Hoss Terms of Service';

  return (
    <Container>
      <ContainerHeader>
        <H3 color="#3c4144">{title}</H3>
      </ContainerHeader>
      <PageContainer>
        <BackLink onClick={() => history.push(`${routePrefix}/contact`)}>
          ← Back to Contact
        </BackLink>
        <TermsContent>
          {isPitPay ? <PitPayTermsContent /> : <TicketHossTermsContent />}
        </TermsContent>
      </PageContainer>
    </Container>
  );
};

export default TermsOfService;
